import "./Common/Activity.api";
export { ActivityDesktop } from "./Desktop/ActivityDesktop.container";
export { ActivityMobile } from "./Mobile/ActivityMobile.container";
export type ActivityActions = "activity.show" | "activity.hide";
